import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  name: "",
};
const transporterNameSlice = createSlice({
  name: "transporterName",
  initialState,
  reducers: {
    setTransporterName: (state, action) => {
      state.name = action.payload;
    },
  },
});

export const { setTransporterName } = transporterNameSlice.actions;
export default transporterNameSlice.reducer;
